import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router/router'
import store from './store/'
import {} from './plugins/directive'
import GlobalComponent from './plugins/GlobalComponent.js'
import filter from './plugins/filter'
import mixin from './plugins/mixin'
import install from './plugins/install'
import axios from 'axios'
import './style/theme.less'
import ViewUI from 'view-design';
import rem from './config/rem'
import {} from './plugins/category/Array'
import {} from './plugins/category/Date'
import {} from './plugins/category/Object'
import {
	ssoUrl,
	baseUrl,
} from './config/env'
Vue.use(filter);
Vue.use(mixin);
Vue.use(VueRouter)
Vue.use(ViewUI)
Vue.use(GlobalComponent)
Vue.use(install)

Vue.prototype.sleep = function(ms) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

const router = new VueRouter({
	routes,
	mode: 'hash',
})
if (process.env.VUE_APP_INNERNODE_ENV == 'production') {
	console.log = function () {
		return false;
	}
}





let access_forbidden = false;

function Check(model, ip, list,to, next) {
	let userInfo = store.state.common.userInfo;
	var CanDo = parseInt(model.WX_AccessControl)
	var oop = model.WX_Maintenance.toLowerCase();
	let toUrl = null
	if (oop == 'true') {
		var iplist = model.WX_MaintenanceWhiteList.split(',')
		if (iplist.indexOf(ip) == -1) {
			toUrl = model.WX_MaintenanceUrl + '?type=' + model.Code
			access_forbidden = true;
		}
	} else if (CanDo != 0 && userInfo) {
		var vipno = userInfo.VipNo;

		//开启访问控制状态  -1 黑名单 1 白名单
		var result = list.filter(u => u.CanDo == CanDo && u.Code == model.Code && vipno == u.UserNo);
		if (CanDo == -1) {
			if (result[0]) //在黑名单中
			{
				toUrl = model.WX_MaintenanceUrl + '?type=' + model.Code
				access_forbidden = true;
			}
		} else {
			if (!result[0]) { //不在白名单中
				toUrl = model.WX_MaintenanceUrl + '?type=' + model.Code
				access_forbidden = true;
			}
		}
	}
	if (to.path.indexOf(model.WX_MaintenanceUrl) != -1 && !access_forbidden) {
		next('/home') 
	}
	if (toUrl && to.path.indexOf(model.WX_MaintenanceUrl) == -1) {
		return toUrl
	}
}

function maintenance(to, next) {
	let sysConfig = store.state.common.sysConfig;
	console.log(sysConfig);
	let url
	if (sysConfig && sysConfig.value && sysConfig.value.maintenance && sysConfig.value.maintenance.length > 0) {
		//是否开启全部维护
		var sys = sysConfig.value.maintenance.filter(u => u.Code == 'OrderPage');
		console.log(sys);
		if (sys[0]) {
			//验证是否开启全部维护
			url = Check(sys[0], sysConfig.value.ip, sysConfig.value.uselist,to, next)
		}
		//校验加入 和订购是否开启维护
		// let code = to.meta.code || to.query.type
		// if (code) {
		// 	var model = sysConfig.value.maintenance.filter(u => u.Code == code);
		// 	if (model[0]) {
		// 		url = Check(model[0], sysConfig.value.ip, sysConfig.value.uselist,to, next)
		// 	}
		// }
	}
	return url
}



router.beforeEach(async (to, from, next) => {
	ViewUI.LoadingBar.start();
	let token = (to.query && to.query.token) || store.state.common.userToken;
	console.log(store.state.common.userToken)
	if(to.query && to.query.token){
		await store.dispatch("getUserInfoAction", token);
	}
	var cacheToken = store.state.common.userToken;
	if (cacheToken) {
		await store.dispatch("getCacheUserInfoAction", cacheToken);
		await store.dispatch("getCacheWechatUserInfoAction")
	}
	
	access_forbidden = false;
	await store.dispatch("getSysConfigAction");
	let url = maintenance(to, next);
	if (access_forbidden) {
		console.log('access_forbidden',url);
		next(url);
		ViewUI.LoadingBar.finish();
		return;
	}
	
	let userInfo = store.state.common.userInfo;
	if (to.meta.requireAuth) {
		if (userInfo) {
			next()
		} else{
			let redirect;
			ViewUI.LoadingBar.finish();
			let toUrl = to.fullPath;
			let regex = /token=\w*(&|$)|(\?|&)token=\w*$/;
			toUrl = toUrl.replace(regex, "");
			if (process.env.NODE_ENV === 'development') {
				redirect = escape(`http://localhost:9000/#${toUrl}`);
				location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
			} else {
				redirect = escape(`${baseUrl}/client/index.html#${toUrl}`);
				location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
			}
		}
	}
	else{
		next();
	}
	if (to.query && to.query.token) {
		delete to.query.token
		next({
			path:to.path,
			query:to.query,
			params:to.params,
		})
	}
})
// const recordBrowsing = (to,from) => {
// 	console.log(to,from)
// 	let PreRoute = from.path
// 	let PageCode = to.path
// 	let checkProp = '',MainId,extend={}
//     if(to.query) {
//         const props = ['code','Code','Id','ID','id','sku']
//         for (const prop of props) {
//             if(to.query[prop]) {
//                 checkProp = prop
//                 break
//             }
//         }
//         let {[checkProp]:tempMainId,...tempExtend} = to.query
//         MainId = tempMainId
//         extend = tempExtend
//     }
// 	store.dispatch("recordBrowsingAction",{
// 		PreRoute,
//         PageCode,
//         MainId,
//         extend:JSON.stringify(extend).substr(0,300),
// 	})
// }
router.afterEach(async (to, from, next) => {
	ViewUI.LoadingBar.finish();
	window.Trace = to.path
	let container = document.getElementById('container')
	container && container.scrollTo({top: 0,});
	//recordBrowsing(to,from)
});

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
